export interface Review {
  id: string;
  author: string;
  product: string;
  comment: string;
}

export const reviews: Review[] = [
  {
    id: 'r1',
    author: 'Mariana G.',
    product: 'Coco Mademoiselle',
    comment:
      'Llegó en dos días y perfectamente empacado. Lo uso desde la mañana y en la noche todavía se percibe.',
  },
  {
    id: 'r2',
    author: 'Andrés R.',
    product: 'Bleu de Chanel',
    comment:
      'Frasco original y sellado, exactamente como en las fotos. Es el que más me han preguntado en la oficina.',
  },
  {
    id: 'r3',
    author: 'Paola V.',
    product: 'Miss Dior Blooming Bouquet',
    comment:
      'Tenía dudas de comprar perfume en línea y la atención por WhatsApp me resolvió todo en minutos.',
  },
  {
    id: 'r4',
    author: 'Diego M.',
    product: 'Versace Eros',
    comment:
      'El precio de lanzamiento y el envío gratis lo hacen difícil de superar. Ya pedí el segundo.',
  },
];
